import React, {useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

const OpeningHoursContainer = styled.div`
    max-width: 800px;
    padding: 20px;
    background: ${(props) => props.theme.colors.background}cc;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
`;

const OpeningHoursHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;

const OpeningHoursTitle = styled.h3`
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.5rem;
    margin: 0;
`;

const OpeningHoursList = styled.ul`
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    max-height: ${(props) => (props.isOpen ? '800px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    opacity: ${(props) => (props.isOpen ? '1' : '0')};
`;

const OpeningHoursItem = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: ${(props) => props.theme.colors.secondary}11;
    border-radius: 8px;
    font-size: 1rem;
    color: ${(props) => props.theme.colors.text};
    transition: transform 0.2s;

    &:hover {
        transform: translateY(-2px);
    }

    span:first-child {
        font-weight: 600;
    }
`;

const OpeningHours = ({rentUser}) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(true);

    const toggleOpeningHours = () => {
        setIsOpen(!isOpen);
    };

    const dayNames = {
        '1': 'monday',
        '2': 'tuesday',
        '3': 'wednesday',
        '4': 'thursday',
        '5': 'friday',
        '6': 'saturday',
        '7': 'sunday',
    };

    const formatOpeningHours = () => {
        if (!rentUser?.openingHoursV2?.regularOpeningHours) {
            return null;
        }

        const daysOrder = ['1', '2', '3', '4', '5', '6', '7'];
        return daysOrder.map((day) => {
            const dayData = rentUser.openingHoursV2.regularOpeningHours.find((d) => d.dayOfWeek === day);
            const displayText = dayData && dayData.isOpen && dayData.hours.length > 0
                ? dayData.hours.map((slot) => `${slot.open} - ${slot.close}`).join(', ')
                : t('closed', {defaultValue: 'Chiuso'});

            return (
                <OpeningHoursItem key={day}>
                    <span>{t(dayNames[day], {defaultValue: dayNames[day].charAt(0).toUpperCase() + dayNames[day].slice(1)})}</span>
                    <span>{displayText}</span>
                </OpeningHoursItem>
            );
        });
    };

    return (
        <OpeningHoursContainer>
            <OpeningHoursHeader onClick={toggleOpeningHours}>
                <OpeningHoursTitle>{t('openingHours', {defaultValue: 'Orari di Apertura'})}</OpeningHoursTitle>
            </OpeningHoursHeader>
            <OpeningHoursList isOpen={isOpen}>{formatOpeningHours()}</OpeningHoursList>
        </OpeningHoursContainer>
    );
};

export default OpeningHours;
